import Installation from './themes/BGH';
export default Installation;

import {
  selectConfiguratorInstallation,
  selectConfiguratorAddon,
  resetConfiguratorAddons,
  resetInstallationConfigurator
} from 'views/ProductPage/configurators/installation/actions';
import { ChangeEventHandler } from 'react';
import { IBasicResponse } from 'models/IBasicResponse';

export interface InstallationProps {
  selectInstallation: typeof selectConfiguratorInstallation;
  selectAddon: typeof selectConfiguratorAddon;
  resetAddons: typeof resetConfiguratorAddons;
  resetConfigurator: typeof resetInstallationConfigurator;
  isInstallationSelected: boolean;
  zipCode: string;
  setZipCode: ChangeEventHandler<HTMLInputElement>;
  handleError(response: IBasicResponse): void;
}
